import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["link", "tabIsOpen", "isDesktop", "sx"],
    _excluded2 = ["link"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Link, UnavailableInLens } from '@infl-ts/ui-advocate-components';
import { useToggle } from '@infl-ts/util-hooks';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { styled } from '@mui/material';
import { pipe } from 'fp-ts/function';
import { forwardRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { jsx as _jsx } from "react/jsx-runtime";
export var LENS_DISABLED_LINKS = ['referrals'];
var RouterLinkHover = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (p) {
  return p.theme.palette.text.secondary;
});
var RouterNavLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var link = _ref.link,
      tabIsOpen = _ref.tabIsOpen,
      isDesktop = _ref.isDesktop,
      sx = _ref.sx,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsx(RouterLinkHover, _objectSpread(_objectSpread({
    sx: mergeSxProps({
      textDecoration: 'none',
      display: 'flex',
      pt: tabIsOpen ? 0.25 : 0,
      borderBottom: tabIsOpen && isDesktop ? '2px solid' : 'none',
      height: '100%',
      color: tabIsOpen ? function (theme) {
        return theme.palette.primary.main;
      } : 'none',
      alignItems: 'center',
      textAlign: 'center',
      fontWeight: function fontWeight(theme) {
        return theme.typography.fontWeightMedium;
      },
      '&:hover': {
        textDecoration: 'none'
      },
      '&:visited': {
        color: tabIsOpen ? function (theme) {
          return theme.palette.primary.main;
        } : 'none'
      }
    }, sx),
    href: link.href,
    color: tabIsOpen ? 'primary' : 'inherit',
    ref: ref
  }, rest), {}, {
    children: link.typename === 'NavBlockLogoLink' ? /*#__PURE__*/_jsx("img", {
      src: link.imgUrl,
      style: {
        width: '50px',
        height: '100%',
        objectFit: 'contain'
      },
      alt: link.display
    }) : t(link.display)
  }));
});
RouterNavLink.displayName = 'RouterNavLink';
export var isCurrentTab = function isCurrentTab(href, pathname, tabUrl) {
  return pipe(tabUrl.replace('/forum/session/sso?return_path=', ''), function (url) {
    return pathname.startsWith(url + '/') || pathname === url || href === url || href.startsWith(url + '/');
  });
};
var NavLink = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var link = _ref2.link,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      tabIsOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      setTabOpen = _useToggle2$.on,
      setTabClosed = _useToggle2$.off;

  var history = useHistory();
  useEffect(function () {
    var handleSetTabIsOpen = function handleSetTabIsOpen(pathname) {
      return isCurrentTab(window.location.href, pathname, link.href) ? setTabOpen() : setTabClosed();
    };

    handleSetTabIsOpen(history.location.pathname);
    return history.listen(function (location) {
      return handleSetTabIsOpen(location.pathname);
    });
  }, [history, link.href]);
  return LENS_DISABLED_LINKS.includes(link.id) ? /*#__PURE__*/_jsx(UnavailableInLens, {
    tooltip: true,
    children: /*#__PURE__*/_jsx(RouterNavLink, _objectSpread(_objectSpread({
      link: link,
      tabIsOpen: tabIsOpen
    }, props), {}, {
      ref: ref
    }))
  }) : /*#__PURE__*/_jsx(RouterNavLink, _objectSpread(_objectSpread({
    link: link,
    tabIsOpen: tabIsOpen
  }, props), {}, {
    ref: ref
  }));
});
NavLink.displayName = 'NavLink';
export default NavLink;